export default class UniqueIdGenerator {
  constructor(initialIdNumber) {
    if (initialIdNumber) {
      this.availableIdNumber = this.initialIdNumber = initialIdNumber;
    } else {
      this.availableIdNumber = 1;
    }
  }

  getId() {
    // id 用文字為佳，因為有時會用id做為物件的key
    let id = `id${this.availableIdNumber}`;
    this.availableIdNumber++;
    return id;
  }

  getCurrentNumber() {
    return this.availableIdNumber;
  }

  reset() {
    this.availableIdNumber = this.initialIdNumber;
  }

}


// WEBPACK FOOTER //
// ./src/commonJS/UniqueIdGenerator.js